var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProductHuntGlyph(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8664 22.8H17.9V27H15.1V13H21.8664C24.5728 13 26.7664 15.1936 26.7664 17.9C26.7664 20.6064 24.5728 22.8 21.8664 22.8ZM20 6C12.2676 6 6 12.2676 6 20C6 27.7324 12.2676 34 20 34C27.7315 34 34 27.7324 34 20C34 12.2676 27.7315 6 20 6ZM21.8664 15.8H17.9V20H21.8664C23.0266 20 23.9664 19.0594 23.9664 17.9C23.9664 16.7406 23.0266 15.8 21.8664 15.8Z",
    fill: "white"
  })));
}

export default SvgProductHuntGlyph;